/*
 * @Author: Christion.Young
 * @Date: 2023-07-18 16:13:15
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-08-13 10:00:00
 * @Description: 入口文件
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import enrich from "./enrich";

// 使用enrich统一管理全局引用
Vue.use(enrich);

Vue.config.productionTip = false;

/**
 * 初始化应用状态 - 简化版
 */
function initializeApp() {
  try {
    // 初始化用户状态
    store.dispatch("user/initUserState");
    console.log("应用初始化完成");
  } catch (error) {
    console.error("应用初始化失败:", error);
  }
}

// 创建Vue实例
const app = new Vue({
  router,
  store,
  render: (h) => h(App),
  created() {
    // 在Vue实例创建后初始化应用状态
    initializeApp();
  },
});

// 挂载应用
app.$mount("#app");
